// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__XfviB","options":"AnswerScale_options__3Z1RJ","selected":"AnswerScale_selected__1V2rO"};